import { readonly, ref } from "vue";

import { adminApi, type AdminSession } from "./api";
import { firebaseUser, signOutAdmin } from "./firebase";

const admin = ref<AdminSession | null>(null);
const accessError = ref("");
let loading: Promise<AdminSession> | null = null;

export function useAdminSession() {
  async function loadSession(force = false) {
    if (admin.value && !force) return admin.value;
    if (loading) return loading;
    loading = adminApi.getSession()
      .then((response) => {
        admin.value = response.admin;
        accessError.value = "";
        return response.admin;
      })
      .catch((error) => {
        admin.value = null;
        accessError.value = error instanceof Error ? error.message : "此帳號沒有後台權限。";
        throw error;
      })
      .finally(() => { loading = null; });
    return loading;
  }

  async function logOut() {
    admin.value = null;
    accessError.value = "";
    await signOutAdmin();
  }

  return {
    admin: readonly(admin),
    firebaseUser,
    accessError: readonly(accessError),
    loadSession,
    logOut,
    hasPermission: (permission: AdminSession["permissions"][number]) =>
      admin.value?.permissions.includes(permission) ?? false
  };
}
